import { service } from '@/utils/request'
const preApi = process.env.VUE_APP_ENV === 'development' ? '/dev' : ''
class user {
  // static login (params) { return service.post('/user/login', params) }
  // static getVerifyCode (params) { return service.get('/user/get_verify_code', { params }) }
  // static register (params) { return service.post('/user/register', params) }
  // static authentication (params) { return service.post('/user/authentication', params) }
  // static resetPassword (params) { return service.post('/user/reset_password', params) } // 用户认证
  // static checkRegister (params) { return service.get('/user/check_register', { params }) }
  // static getUserInfo (params) { return service.get('/user/get_user_info', { params }) }
  // static updateUserInfo (params) { return service.post('/user/update_user_info', params) }
  // static bingBankCard (params) { return service.post('/user/bind_bank_card', params) }
  // static bindAlipay (params) { return service.post('/user/bind_alipay', params) }
  // static cancel (params) { return service.post('/user/cancel', params) }
  // static get_cancel_info (params) { return service.get('/user/cancel_info', { params }) }
  // 用户登录
  static login (params) { return service.post('/api/user/login', params) }
  // 获取验证码
  static getVerifyCode (params) { return service.get('/api/user/get_verify_code', { params }) }
  // 用户注册
  static register (params) { return service.post('/api/user/register', params) }
  // 用户认证
  static authentication (params) { return service.post('/api/user/authentication', params) }
  // 重置密码
  static resetPassword (params) { return service.post('/api/user/reset_password', params) } // 用户认证
  // 检测是否注册
  static checkRegister (params) { return service.get(preApi + '/user/check_register', { params }) }
  // 获取用户信息
  static getUserInfo (params) { return service.get('/api/user/get_user_info', { params }) }
  // 更新用户信息
  static updateUserInfo (params) { return service.post('/api/user/update_user_info', params) }
  // 绑定银行卡 废弃
  static bingBankCard (params) { return service.post(preApi + '/user/bind_bank_card', params) }
  // 绑定支付宝
  static bindAlipay (params) { return service.post('/api/user/bind_alipay', params) }
  // 用户注销
  static cancel (params) { return service.post(preApi + '/user/cancel', params) }
  // 获取注销信息
  static get_cancel_info (params) { return service.get(preApi + '/user/cancel_info', { params }) }
  // 获取用户帮助
  static get_help_info (params) { return service.get('/api/vane/user_help_info', { params }) }
  // 用户反馈提交
  static submit_feedback (params) { return service.post('/api/user/create_feedback', params) }
  // 同意主体更换
  static agree_change_body (params) { return service.post('/api/user/agree_change_body', params) }
}

export default user
